"use client";

import clsx from "clsx";

/**
 * Stylised phone device frame for screens 0.3 (Aurora drafting on her phone)
 * and 0.4 (Al Madar receiving the link). The intent is the same as the
 * <Monogram> rule (Decision 9): visual abstraction that signals "this is a
 * phone" without committing to an OS or specific device.
 */
export function PhoneFrame({
  children,
  status = "Tuesday · 14:02",
  className,
}: {
  children: React.ReactNode;
  status?: string;
  className?: string;
}) {
  return (
    <div className={clsx("relative mx-auto w-[320px] overflow-hidden rounded-[36px] border border-state-verified/30 bg-orbitra-ink shadow-glass", className)}>
      <div className="flex items-center justify-between px-7 pt-3 pb-1 font-mono text-[10px] uppercase tracking-wider text-orbitra-teal-soft">
        <span>{status.split("·")[0]?.trim()}</span>
        <span className="flex items-center gap-1.5">
          <span>●●●</span>
          <span>{status.split("·")[1]?.trim()}</span>
        </span>
      </div>
      <div className="px-3 py-2">{children}</div>
      <div className="flex justify-center pb-2">
        <span className="h-1 w-24 rounded-full bg-orbitra-muted/40" />
      </div>
    </div>
  );
}
